var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "v-flex",
        [
          _vm._v("\n    " + _vm._s(_vm.value) + "\n    "),
          _c(
            "v-btn",
            { on: { click: _vm.triggerUpdate } },
            [_c("v-icon", [_vm._v("update")])],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }